import { useEffect } from "react";
import { blockPageGuide, unblockPageGuide } from "./pageGuide";

/** Hide page guides while a modal or overlay is mounted. */
export function useBlockPageGuideWhileMounted(): void {
  useEffect(() => {
    blockPageGuide();
    return () => unblockPageGuide();
  }, []);
}

/**
 * Render inside Radix Dialog/AlertDialog Content so blocking only runs while
 * the portal content is present (open), not when the wrapper is in the tree.
 */
export function DialogGuideBlocker() {
  useBlockPageGuideWhileMounted();
  return null;
}
